/**
 * 将设备数据中的 created_at 字段转换为 YYYY/MM/DD HH:mm:ss 格式的字符串
 * @param {any} device 
 */
export function transformDate(device) {
    const date = new Date(device.created_at);
    const formattedDate = date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
    });

    return {
        ...device,
        created_at: formattedDate
    }
}

import Toastify from 'toastify-js'
import 'toastify-js/src/toastify.css'

const baseStyle = {
  fontSize: "26px",
  padding: "14px 22px",
  minWidth: "320px",
  borderRadius: "6px",
  color: "#fff",
}

// 新增 duration 参数，默认为 3000ms
function showToast(text, bgColor, duration = 3000) {
  Toastify({
    text,
    duration,
    gravity: "top",
    position: "right",
    style: {
      ...baseStyle,
      background: bgColor
    }
  }).showToast()
}

export function showSuccess(msg, duration) {
  showToast(msg, "linear-gradient(to right, #4caf50, #81c784)", duration)
}

export function showError(msg, duration = 5000) { // 默认错误弹窗显示 5000ms
  showToast(msg, "linear-gradient(to right, #f44336, #e57373)", duration)
}

export function showInfo(msg, duration) {
  showToast(msg, "linear-gradient(to right, #2196f3, #64b5f6)", duration)
}

export function showWarning(msg, duration = 4000) { // 默认警告弹窗显示 4000ms
  showToast(msg, "linear-gradient(to right, #ff9800, #ffb74d)", duration)
}